module.exports = __webpack_public_path__ + "img/person_menu_trash_select.21c36240.svg";